/* LODYFAIR BASE — Horizon. 10 oktober 2026 (basisbouwer).

   Wat Impulse theme.js voor de site-brede LodyFair-onderdelen deed en Horizon niet heeft:

   1. DE MENULADE (#NavDrawer, snippets/lodyfair-drawer-menu)
      Zelfde klassen als Impulse, zodat de live CSS en het paneelscript in de lade
      ongewijzigd werken: openen zet `js-drawer-open` op <html> en `drawer--is-open` op de
      lade; alles met `.js-drawer-close` sluit (zonder preventDefault: een link in de lade
      navigeert gewoon en de lade gaat dicht). Escape sluit — het paneelscript in de lade
      luistert eerder (capture op document) en houdt Escape tegen zolang er een subpaneel open
      staat, precies zoals live tegenover Impulse.
      API: window.lfMenu.open(), .sluit()

   2. TELLER OP DE TAS bij paginawissel uit de bfcache (pageshow) — de lade
      (assets/lodyfair-cart.js) houdt [data-lf-cart-telling] verder zelf bij.

   Laden: <script src="lodyfair-base.js" defer> in layout/theme.liquid. Geen afhankelijkheden. */
(function () {
  'use strict';

  var html = document.documentElement;

  /* ---------- 1. menulade ---------- */
  var lade = document.getElementById('NavDrawer');
  var herkomst = null;
  var sluitTimer = null;

  function openMenu(knop) {
    if (!lade) return;
    if (sluitTimer) { clearTimeout(sluitTimer); sluitTimer = null; }
    herkomst = knop || document.activeElement;
    lade.classList.add('drawer--is-klaar');
    /* Eén frame wachten zodat de overgang vanaf de uitgangspositie start. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        lade.classList.add('drawer--is-open');
      });
    });
    html.classList.add('js-drawer-open');
    var knoppen = document.querySelectorAll('.js-drawer-open-nav');
    for (var i = 0; i < knoppen.length; i++) knoppen[i].setAttribute('aria-expanded', 'true');
    lade.setAttribute('aria-hidden', 'false');
    var eerste = lade.querySelector('.drawer__close-button');
    if (eerste) { try { eerste.focus({ preventScroll: true }); } catch (e) { eerste.focus(); } }
  }

  function sluitMenu() {
    if (!lade || !lade.classList.contains('drawer--is-open')) return;
    lade.classList.remove('drawer--is-open');
    html.classList.remove('js-drawer-open');
    html.classList.add('js-drawer-closing');
    var knoppen = document.querySelectorAll('.js-drawer-open-nav');
    for (var i = 0; i < knoppen.length; i++) knoppen[i].setAttribute('aria-expanded', 'false');
    lade.setAttribute('aria-hidden', 'true');
    sluitTimer = setTimeout(function () {
      lade.classList.remove('drawer--is-klaar');
      html.classList.remove('js-drawer-closing');
      sluitTimer = null;
    }, 450);
    if (herkomst && typeof herkomst.focus === 'function' && document.contains(herkomst)) {
      try { herkomst.focus({ preventScroll: true }); } catch (e) { herkomst.focus(); }
    }
    herkomst = null;
  }

  if (lade) {
    lade.setAttribute('aria-hidden', 'true');

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var open = e.target.closest('.js-drawer-open-nav');
      if (open) { e.preventDefault(); openMenu(open); return; }
      if (e.target.closest('.js-drawer-close') && html.classList.contains('js-drawer-open')) { sluitMenu(); }
    });

    /* Zoeken vanuit de lade (data-lf-zk-open): de zoeklade (assets/lodyfair-zoek.js, bouwer Winkel)
       opent zelf. Is die er niet, dan gaat de knop naar /search. */
    lade.addEventListener('click', function (e) {
      var zoek = e.target.closest ? e.target.closest('[data-lf-zk-open]') : null;
      if (!zoek) return;
      if (!document.querySelector('[data-lf-zk]') && !window.lfZoek) {
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search';
      }
    });

    /* Escape: op window (bubbel), zodat het paneelscript in de lade (capture op document) eerst
       een subpaneel kan sluiten en dan stopPropagation doet. */
    window.addEventListener('keyup', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && html.classList.contains('js-drawer-open')) sluitMenu();
    });

    /* Focus binnen de lade houden zolang hij open is. */
    lade.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !lade.classList.contains('drawer--is-open')) return;
      var alles = lade.querySelectorAll('button, a[href], input, select, [tabindex]:not([tabindex="-1"])');
      var lijst = [];
      for (var i = 0; i < alles.length; i++) {
        var el = alles[i];
        if (el.disabled || el.closest('[inert]') || el.closest('[aria-hidden="true"]')) continue;
        if (!el.getBoundingClientRect().height) continue;
        lijst.push(el);
      }
      if (!lijst.length) return;
      var eerste = lijst[0], laatste = lijst[lijst.length - 1];
      if (e.shiftKey && document.activeElement === eerste) { e.preventDefault(); laatste.focus(); }
      else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
    });

    /* Vanaf 750px is er geen hamburger; een open lade bij draaien/vergroten sluiten. */
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 750px)');
      var bijWissel = function (m) { if (m.matches) sluitMenu(); };
      if (mq.addEventListener) mq.addEventListener('change', bijWissel); else if (mq.addListener) mq.addListener(bijWissel);
    }
  }

  window.lfMenu = { open: openMenu, sluit: sluitMenu };

  /* ---------- 2. teller na terugkeer uit de bfcache ---------- */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !window.fetch) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var n = c.item_count;
        var rondjes = document.querySelectorAll('[data-lf-cart-telling]');
        for (var i = 0; i < rondjes.length; i++) {
          rondjes[i].textContent = n;
          if (n > 0) rondjes[i].removeAttribute('hidden'); else rondjes[i].setAttribute('hidden', '');
        }
      })
      .catch(function () {});
  });
})();

/* De WhatsApp-knop ontwijkt vaste lagen sinds Thema v2 ronde 3 via assets/lf-zweef.js (schuift mee i.p.v. verdwijnen). */
